module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp123_7005.b883d2b9.png";